import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CoreComponent } from "./core.component";
import { AuthGuardService } from "../guards/auth-guard.service";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AdminGuardService } from "../guards/admin-guard.service";
import { ChangePasswordComponent } from "./change-password/change-password.component";

const routes: Routes = [
    {
        path: "core",
        component: CoreComponent,
        canActivate: [AuthGuardService],
        children: [
            { path: "", pathMatch: "full", redirectTo: "dashboard" },
            { path: "dashboard", component: DashboardComponent },
            { path: "change-password", component: ChangePasswordComponent },
            {
                path: "setups",
                loadChildren: "./setup/setup.module#SetupModule",
            },
            { path: "users", loadChildren: "./users/users.module#UsersModule" },
            { path: "roles", loadChildren: "./roles/roles.module#RolesModule" },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    declarations: [],
})
export class CoreRoutingModule {}
